<template>
  <div class="driver_rates_page">
    <!-- SECTION TITLE BAR -->
    <div class="rates_header_bar mb-4">
      <div class="title_group">
        <i class="fal fa-star icon_star"></i>
        <div>
          <h5 class="m-0 font-weight-bold">تقييمات وآراء العملاء</h5>
          <span class="text-muted text_small"
            >انطباعات وملاحظات متلقي الخدمة عن السائق</span
          >
        </div>
      </div>
      <span class="count_badge" v-if="allData && allData.length">
        <i class="fal fa-comments me-1"></i>
        {{ allData.length }} تقييم
      </span>
    </div>

    <!-- LOADER STATE -->
    <div class="py-5 text-center" v-if="loading">
      <v-progress-circular
        indeterminate
        color="purple darken-2"
        size="50"
        width="4"
      ></v-progress-circular>
      <p class="mt-3 text-muted font-weight-bold">جاري تحميل التقييمات...</p>
    </div>

    <!-- EMPTY STATE CONTAINER (WHEN NO RATES EXIST) -->
    <div
      class="empty_rates_card py-5 px-4 text-center my-4"
      v-else-if="!loading && (!allData || allData.length === 0)"
    >
      <div class="empty_icon_wrapper mx-auto mb-4">
        <div class="empty_icon_box">
          <i class="fal fa-star"></i>
        </div>
        <div class="pulse_ring"></div>
      </div>
      <h4 class="empty_title font-weight-bold mb-2">لا توجد تقييمات مسجلة</h4>
      <p
        class="empty_subtitle text-muted mx-auto mb-4"
        style="max-width: 480px"
      >
        لم يتم إضافة أي تقييمات أو ملاحظات من قبل العملاء على خدمات هذا السائق
        حتى الآن.
      </p>
    </div>

    <!-- RATES LIST GRID -->
    <div class="row g-4" v-else-if="allData && allData.length">
      <div
        class="col-xl-6 col-lg-6 col-md-12 col-12 mb-4"
        v-for="item in allData"
        :key="item.id"
      >
        <RatingStars
          :image="item.rated_by ? item.rated_by.avatar : null"
          :rateNum="item.rate_value"
          :name="item.rated_by ? item.rated_by.full_name : 'عميل'"
          :desc="item.review || 'لا توجد تعليقات إضافية'"
        ></RatingStars>
      </div>
    </div>
  </div>
</template>

<script>
import RatingStars from "@/components/Global/UserRate.vue";

export default {
  props: ["userInfo"],
  components: {
    RatingStars,
  },
  data() {
    return {
      allData: null,
      loading: false,
    };
  },

  methods: {
    setRows() {
      if (!this.userInfo || !this.userInfo.id) return;
      this.loading = true;
      this.$axios({
        method: "GET",
        url: "driver/" + this.userInfo.id + "/rates",
      })
        .then((res) => {
          this.allData = res.data.data || [];
          this.loading = false;
        })
        .catch(() => {
          this.allData = [];
          this.loading = false;
        });
    },
  },
  created() {
    this.setRows();
  },
};
</script>

<style lang="scss" scoped>
.driver_rates_page {
  /* SECTION TITLE BAR */
  .rates_header_bar {
    background: #ffffff;
    border-radius: 20px;
    padding: 18px 24px;
    border: 1px solid rgba(226, 232, 240, 0.9);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02);

    .title_group {
      display: flex;
      align-items: center;
      gap: 14px;

      .icon_star {
        font-size: 1.5rem;
        color: #f59e0b;
      }

      .text_small {
        font-size: 0.825rem;
      }
    }

    .count_badge {
      font-size: 0.85rem;
      font-weight: 700;
      padding: 6px 16px;
      border-radius: 50px;
      background: rgba(245, 158, 11, 0.12);
      color: #d97706;
    }
  }

  /* EMPTY STATE */
  .empty_rates_card {
    background: #ffffff;
    border-radius: 24px;
    border: 1px solid rgba(226, 232, 240, 0.9);
    box-shadow: 0 10px 25px -5px rgba(15, 23, 42, 0.04);
    padding: 60px 20px;

    .empty_icon_wrapper {
      position: relative;
      width: 90px;
      height: 90px;

      .empty_icon_box {
        width: 90px;
        height: 90px;
        border-radius: 26px;
        background: linear-gradient(
          135deg,
          rgba(245, 158, 11, 0.12) 0%,
          rgba(245, 158, 11, 0.04) 100%
        );
        border: 2px dashed rgba(245, 158, 11, 0.35);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2.4rem;
        color: #f59e0b;
        position: relative;
        z-index: 2;
      }

      .pulse_ring {
        position: absolute;
        inset: -8px;
        border-radius: 30px;
        background: rgba(245, 158, 11, 0.1);
        z-index: 1;
        animation: pulseRing 2.5s infinite ease-in-out;
      }
    }

    .empty_title {
      font-size: 1.25rem;
      color: #1e293b;
    }

    .empty_subtitle {
      font-size: 0.9rem;
      line-height: 1.6;
    }
  }
}

@keyframes pulseRing {
  0% {
    transform: scale(0.95);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.2;
  }
  100% {
    transform: scale(0.95);
    opacity: 0.6;
  }
}
</style>
